import { render, staticRenderFns } from "./only_form.vue?vue&type=template&id=351a2e52&scoped=true&"
import script from "./only_form.vue?vue&type=script&lang=js&"
export * from "./only_form.vue?vue&type=script&lang=js&"
import style0 from "./only_form.vue?vue&type=style&index=0&id=351a2e52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a2e52",
  null
  
)

export default component.exports